import { render, staticRenderFns } from "./wbdp-feedback.vue?vue&type=template&id=27b27d13"
import script from "./wbdp-feedback.vue?vue&type=script&lang=js"
export * from "./wbdp-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports